module.exports = __webpack_public_path__ + "static/img/console_trade_inspect.8cf6d43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/console_trade_inspect.png
// module id = sUiF
// module chunks = 8